import React, { FC } from 'react'
import { Text, Stack } from '@lojinha/design-system'
import { Coin, UserCircle } from '@lojinha/design-system/src/icons'
import { numberToCurrency, testId } from '@lojinha/helpers'
import { t } from '../../dictionary'
import { acceptedInvitationsToFormattedText } from '../../helpers/formatPhrase'
import { numberToCurrencyAriaLabel } from '../../helpers/formatNumber'
import { ThickerCard, Container, TextContainer } from './styles'

type CardsGroupProps = {
  credits?: number | null
  acceptedInvites?: number | null
}

export const CardsGroup: FC<CardsGroupProps> = ({
  credits,
  acceptedInvites,
}) => {
  const hasCredits = !!credits && credits > 0
  const hasInvites = !!acceptedInvites && acceptedInvites > 0

  if (!hasCredits && !hasInvites) return null

  return (
    <Container layout="horizontal" margin={['x8', 'x16']}>
      {hasCredits && (
        <ThickerCard
          padding={'x16'}
          htmlAttrs={{
            'aria-label': `${t.youHave} ${numberToCurrencyAriaLabel(
              credits ?? 0
            )} ${t.inCredits}`,
          }}
          {...testId('credits-card')}
        >
          <Stack layout={'horizontal'}>
            <Coin size={'x3'} />
            <TextContainer>
              <Text textSize={'x2'} isBold={true} {...testId('credits-text')}>
                {numberToCurrency(credits)}
              </Text>
              <Text color={'gray700'} textSize={'x1'}>
                {t.yourCredits}
              </Text>
            </TextContainer>
          </Stack>
        </ThickerCard>
      )}

      {hasInvites && (
        <ThickerCard
          padding={'x16'}
          htmlAttrs={{
            'aria-label': `${t.youHave} ${acceptedInvites} ${t.acceptedInvitations}`,
          }}
          {...testId('invites-card')}
        >
          <Stack layout={'horizontal'}>
            <UserCircle size={'x3'} />
            <TextContainer>
              <Text
                textSize={'x2'}
                isBold={true}
                {...testId('accepted-invites-text')}
              >
                {acceptedInvitationsToFormattedText(acceptedInvites ?? 0)}
              </Text>
              <Text color={'gray700'} textSize={'x1'}>
                {t.yourInvitations}
              </Text>
            </TextContainer>
          </Stack>
        </ThickerCard>
      )}
    </Container>
  )
}

CardsGroup.defaultProps = {
  credits: 0,
  acceptedInvites: 0,
}
